import { render, staticRenderFns } from "./SetDefaultDialog.vue?vue&type=template&id=2bdac525"
import script from "./SetDefaultDialog.vue?vue&type=script&lang=js"
export * from "./SetDefaultDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports